import { render, staticRenderFns } from "./AdminUserForm.vue?vue&type=template&id=2efb144d&scoped=true"
import script from "./AdminUserForm.vue?vue&type=script&lang=js"
export * from "./AdminUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb144d",
  null
  
)

export default component.exports